import { render, staticRenderFns } from "./MyFeedbackItems.vue?vue&type=template&id=69670bb6"
import script from "./MyFeedbackItems.vue?vue&type=script&lang=js"
export * from "./MyFeedbackItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69670bb6')) {
      api.createRecord('69670bb6', component.options)
    } else {
      api.reload('69670bb6', component.options)
    }
    module.hot.accept("./MyFeedbackItems.vue?vue&type=template&id=69670bb6", function () {
      api.rerender('69670bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MyFeedbackItems.vue"
export default component.exports